import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/Flow/editor/floweditor.tsx",
    () => import("./floweditor"),
);
